import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { Alert, Badge, Table } from "react-bootstrap";

import Loader from "../../Loader/Loader";
import ErrorHandler from "../../ErrorHandler/ErrorHandler";
import OptimizedFilingPreview from "../OptimizedFilingPreview/OptimizedFilingPreview";
import moment from "moment";
import { orderBy } from "lodash";
import "./OptimizedFilingList.scss";
import { abbrivateCategories } from "../../../utils/StringUtils";
import DeleteIcon from "mdi-react/DeleteIcon";
import OptimizedFilingPreviewPgm from "../OptimizedFilingPreview/OptimizedFilingPreviewPgm";

class OptimizedFilingListPgm extends Component {
  constructor(props) {
    super(props);
    this.subscribedPromises = [];
    this.state = {
      sortable: props?.sortable || false,
      filings: props?.filings || [],
      sortColumnMapping: {
        Company: { column: "companyNameLong", direction: "desc" },
        "accession No": { column: "accessionNo", direction: "desc" },
        "Filed At": { column: "filedAtDate", direction: "desc" },
        Ticker: { column: "ticker", direction: "desc" },
        CIK: { column: "cik", direction: "desc" },
        Analyst: {
          column: "analystAssigned",
          direction: "desc",
        },
      },

      sortBy: "",
      sortSelection: {},
    };
  }

  componentDidMount() {
    this.setState({ filings: this.props?.filings || [] });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.filings !== this.props.filings) {
      this.setState({ filings: this.props?.filings || [] });
    }
  }

  updateStateData() {
    this.setState({ filings: this.props?.filings || [] });
  }

  showDocument(filing, doc) {
    this.setState({ preview: { filing: filing, doc: doc } });
  }

  hideDocument() {
    this.setState({ preview: null });
  }

  handleSortBy = (title) => {
    let { sortColumnMapping, sortSelection } = this.state;
    sortColumnMapping = {
      ...sortColumnMapping,
      [title]: {
        ...sortColumnMapping[title],
        direction:
          sortColumnMapping[title].direction === "asc" ? "desc" : "asc",
      },
    };
    sortSelection = {
      ...sortSelection,
      [title]: sortColumnMapping[title],
    };

    console.log(123, sortColumnMapping, sortSelection);

    this.setState(
      {
        sortColumnMapping: sortColumnMapping,
        sortBy: title,
        sortSelection: sortSelection,
      },
      () => {
        this.sortData();
      }
    );
  };

  Heading = ({ title, classes = "" }) => {
    const { sortSelection, sortBy } = this.state;
    const direction = sortSelection[title]?.direction;
    const iconAsc = "south";
    const iconAscClass =
      sortBy === title && direction && (direction === "asc" ? "active" : "");
    const iconDesc = "north";
    const iconDescClass =
      sortBy === title && direction && (direction === "desc" ? "active" : "");
    return (
      <th
        className={classes}
        role={"button"}
        onClick={() => this.handleSortBy(title)}
      >
        {title}
        <span className={`material-icons sort ${iconAscClass}`}>{iconAsc}</span>
        <span className={`material-icons sort ${iconDescClass}`}>
          {iconDesc}
        </span>
      </th>
    );
  };

  sortData = () => {
    if (this.state.sortBy !== "") {
      const { sortColumnMapping, filings } = this.state;
      const column = sortColumnMapping[this.state.sortBy].column;
      const direction = sortColumnMapping[this.state.sortBy].direction;
      console.log(column, direction);
      this.setState({
        filings: orderBy(filings, column, direction),
      });
    }
  };

  render() {
    const { preview, isLoading, error, sortable, filings } = this.state;
    const {
      catalogue,
      selections,
      queryByFetch,
      handleCheckboxChange,
      handleCheckAllChange,
      selectedFiles,
      allFilesSelected,
      assignedAnalyst,
    } = this.props;
    const { Heading } = this;
    if (isLoading) return <Loader />;
    if (error) return <ErrorHandler error={error} />;

    return (
      <Fragment>
        {filings.length ? (
          <div>
            <Table
              // id="filing_table"
              // responsive="sm"
              style={{ width: "100%", marginTop: "5px" }}
              hover
              // className={`filings table-hover`}
            >
              <thead className="responsive-th-optimized-search">
                <tr>
                  <th>SR</th>
                  <Heading
                    classes="text-left"
                    title="Company"
                    isSortable={sortable && true}
                  />
                  <Heading
                    classes="text-left"
                    title="Ticker"
                    isSortable={sortable && true}
                  />
                  <Heading
                    classes="text-left"
                    title="CIK"
                    isSortable={sortable && true}
                  />
                  <Heading
                    classes="text-inline"
                    title="accession No"
                    isSortable={sortable && true}
                  />
                  <Heading
                    classes="text-inline"
                    title="Filed At"
                    isSortable={sortable && true}
                  />
                  <th className="text-left" style={{ paddingLeft: "1%" }}>
                    Form
                  </th>
                  <th>Filing</th>
                </tr>
              </thead>
              <tbody>
                {filings.map((filing, index) => {                  
                  let filingTime = moment(filing.filedAt)
                    .toDate()
                    .toLocaleTimeString("en-US", {
                      timeZone: "America/New_York",
                      hour: "2-digit",
                      minute: "2-digit",
                    });

                  return (
                    <tr key={Math.random() * index}>
                      <td>{++index}</td>
                      {/* Multiple Company Names display ( below ) */}
                      <td>{filing.companyName}</td>
                      {/* <td>
                        {filing?.map((entity) => {
                          return (
                            <React.Fragment key={Math.random() * index}>
                              {entity.companyName}
                              <br />
                            </React.Fragment>
                          );
                        })}
                      </td> */}
                      <td>{filing.ticker}</td>
                      <td>{filing.cik}</td>
                      <td className="text-muted text-inline">
                        {filing.accessionNo}
                        {/* {filingTime} */}
                      </td>
                      <td className="text-muted text-inline">
                        {filing.filingDate
                          ? moment(filing.filingDate).format("YYYY-MM-DD")
                          : "n/a"}
                      </td>

                      <td>
                        <button
                          key={Math.random() * index}
                          className={`mr-1 roundedEdges line-heigh btn btn-outline-deal-style btn-sm`}
                          onClick={() => {
                            console.log("filing", filing);
                            const doc = [filing.documentFormatFiles];
                            this.showDocument(filing, doc);
                          }}
                        >
                          {/* {doc.type}{" "} */}
                          {/* {inventories.map((item, index) => (
                            <Badge
                              variant="dark"
                              size="sm"
                              className="ml-1 mr-1"
                              style={{ position: "inherit" }}
                              key={Math.random() * index}
                              title={item.name}
                            >
                              {item.name.match(/\b(\w)/g).join("")}
                            </Badge>
                          ))} */}
                          {/* {categories.map((item, index) => (
                            <Badge
                              variant="dark"
                              size="sm"
                              className="ml-1 mr-1"
                              style={{ position: "inherit" }}
                              key={Math.random() * index}
                              title={item.name}
                            >
                              {abbrivateCategories(item.name)}
                            </Badge>
                          ))} */}
                          {filing.formType}
                        </button>
                      </td>

                      <td>
                        <a
                          target="_blank"
                          rel="noreferrer"
                          className="documentClass"
                          href={`https://www.sec.gov/Archives/edgar/data/${
                            filing.cik
                          }/${filing.accessionNo.replace(/-/gi, "")}/${
                            filing.accessionNo
                          }-index.html`}
                        >
                          <span className="material-icons">launch</span>
                        </a>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        ) : (
          <Alert variant="info">
            <h4 className="mb-0">No items to show</h4>
          </Alert>
        )}
        {preview && (
          <OptimizedFilingPreviewPgm
            filing={preview.filing}
            doc={preview.doc}
            btnShow={true}
            user={this.props?.user}
            onDocumentClosed={() => this.hideDocument()}
            selections={selections}
            catalogue={catalogue}
            onCatalogueAdd={this.props.onCatalogueAdd}
            onCatalogueRemove={this.props.onCatalogueRemove}
          />
        )}
      </Fragment>
    );
  }
}

OptimizedFilingListPgm.propTypes = {
  filings: PropTypes.array.isRequired,
  catalogue: PropTypes.array.isRequired,
  selections: PropTypes.array.isRequired,
  onCatalogueAdd: PropTypes.func.isRequired,
  onCatalogueRemove: PropTypes.func.isRequired,
};

export default OptimizedFilingListPgm;
